export const version = "transactions/5.6.1";
//# sourceMappingURL=_version.js.map